var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticStyle:{"margin":"10px 0 10px 0","width":"100px"},attrs:{"src":_vm.appLogo2,"alt":"site logo"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }